import {Phase2Api} from "./api";
import {ValidationRule} from "antd/lib/form";
import React from "react";

export function createChargeCodeValidator(api: Phase2Api){

    return (rule: ValidationRule, chargeCode: string, callback: (msg?: React.ReactNode) => void) => {
        const defaultChargeCode = api.chargeCodes.getDefault();

        // If a default charge code is set, blank fields are allowed — the default will be used on save.
        if (defaultChargeCode){
            callback();
            return;
        }

        // No default set: charge code is required on each entity individually.
        if (!chargeCode){
            callback(rule.message || 'Charge code is required');
            return;
        }

        callback();
    }
}